/* ============================================================
   ILEV · GIFT CARD EN EL CARRITO  (componente reutilizable)
   ------------------------------------------------------------
   24-sep-2026: nace para la Hot List del Cyber ($5.000 desde $50.000).
   25-sep-2026: Franco decide que el mismo componente se usa en el
   día a día (evergreen) con $2.000 o $3.000, para carritos
   abandonados o flash. Por eso hay una LISTA de campañas abajo.

   Cómo funciona
   · Cada campaña es un código de descuento de Shopify (codigo): monto
     fijo al pedido, con mínimo, combinable con descuentos de producto.
     Lo aplica Shopify; este archivo solo DIBUJA la tarjeta sobre el
     total del carrito:
       1. Bloqueada → falta plata para el mínimo: barra de avance.
       2. Lista     → pasó el mínimo y el código no está: botón
                      «Usar mi gift card» (aplica el código).
       3. Aplicada  → Shopify ya descontó: tarjeta brillante.
   · Dos tipos de vigencia:
       'ventana'  → fechas fijas (ej. Hot List: 20:00 a 01:00).
       'personal' → N horas desde que el cliente llega por el link
                    (ej. carrito abandonado: 24 h). Se guarda en su navegador.
   · La tarjeta aparece si el cliente llegó con ?gc=<id> o con
     /discount/<CODIGO>, o si el código ya está en el carrito.
   · Vista de prueba: ?giftcard_demo=<id> (ej. ?giftcard_demo=hotlist-cyber).
   · El código de Shopify tiene que tener el MISMO monto, mínimo y fechas.

   Se carga desde snippets/ilev-carrito-carga.liquid.
   30-sep-2026: PRENDIDO en el tema «NO BORRAR ILEV PREVENTA CYBER» para la
   noche de la Hot List (30-sep 20:00 → 1-oct 01:00). ?hotlist=1 también vale.
   30-sep 17:15: al pasar el mínimo aparece un POP-UP con la visual del hero
   CYBER del home («Activar mi gift card»). Reemplaza al auto-aplicado.
   30-sep 17:30: la tarjeta (carrito y pop-up) es la MISMA de /pages/hotlist-cyber
   y al activarla el carrito lateral se reabre con la gift card activada.
   30-sep 17:55: si el carrito baja de $50.000 y vuelve a pasarlos, el pop-up sale otra vez.
   30-sep 18:45: la Hot List se abre a TODOS los clientes (todos: true) y a la 1:00
   la gift card se quita sola del carrito (limpiarVencidas). 1 uso por cliente en Shopify.
   ============================================================ */
(function () {
  'use strict';
  if (window.__ilevGiftcard) return;
  window.__ilevGiftcard = true;

  /* ================= CAMPAÑAS ================= */
  var CAMPANAS = [
    {
      id: 'cierre-cyber', activa: true, todos: true,   /* 5-oct (Franco): flash «cierre de Cyber», mismo sistema que la Hot List */
      codigo: 'GIFTCARD-CIERRE', monto: 5000, minimo: 50000,
      etiqueta: 'Cierre Cyber',
      tipo: 'ventana',
      desde: '2026-10-07T18:00:00-03:00', hasta: '2026-10-08T00:00:00-03:00',   /* mié 7-oct 18:00 → medianoche */
      txtVence: 'Válida hasta las 23:59', txtPaga: 'Paga antes de medianoche'
    },
    {
      id: 'hotlist-cyber', activa: true, todos: true,   /* 30-sep: la ve TODO cliente que pase el mínimo, no solo la Hot List */
      codigo: 'GIFTCARD-HOTLIST', monto: 5000, minimo: 50000,
      etiqueta: 'Hot List Cyber',
      tipo: 'ventana',
      desde: '2026-09-30T18:37:00-03:00', hasta: '2026-10-01T01:00:00-03:00',   /* 30-sep 18:37: Franco la adelanta para ver la dinámica */
      txtVence: 'Válida hasta la 1:00 AM', txtPaga: 'Paga antes de la 1:00 AM'
    },
    /* --- evergreen: plantillas, apagadas hasta que se creen los códigos --- */
    {
      id: 'carrito-3000', activa: false,
      codigo: 'GIFTCARD-3000', monto: 3000, minimo: 40000,
      etiqueta: 'Regalo ILEV',
      tipo: 'personal', horas: 24,
      txtVence: 'Vence en', txtPaga: 'Vence en'
    },
    {
      id: 'flash-2000', activa: false,
      codigo: 'GIFTCARD-2000', monto: 2000, minimo: 30000,
      etiqueta: 'Flash',
      tipo: 'personal', horas: 4,
      txtVence: 'Vence en', txtPaga: 'Vence en'
    }
  ];
  var CLAVE = 'ilev_giftcard';
  /* ============================================ */

  var qs = location.search;
  var ahora = Date.now();
  var mDemo = qs.match(/[?&]giftcard_demo=([^&]+)/);
  var mGc = qs.match(/[?&]gc=([^&]+)/);
  var ruta = location.pathname.toLowerCase();

  function guardado() { try { return JSON.parse(localStorage.getItem(CLAVE) || '{}'); } catch (e) { return {}; } }
  function guardar(o) { try { localStorage.setItem(CLAVE, JSON.stringify(o)); } catch (e) {} }

  /* recordar la campaña con la que llegó el cliente (y cuándo) */
  var mem = guardado();
  CAMPANAS.forEach(function (c) {
    var llego = (mGc && mGc[1] === c.id) || ruta.indexOf('/discount/' + c.codigo.toLowerCase()) === 0 ||
                (c.id === 'hotlist-cyber' && /[?&]hotlist=1/.test(qs));   /* link antiguo de la Hot List */
    if (llego && !mem[c.id]) { mem[c.id] = ahora; guardar(mem); }
  });

  function fin(c, demo) {
    if (c.tipo === 'ventana') {
      var d = Date.parse(c.desde), h = Date.parse(c.hasta);
      if (demo && (ahora < d || ahora > h)) return ahora + (h - d);   /* demo: ventana completa desde ahora */
      return (ahora >= d && ahora <= h) ? h : 0;
    }
    var t0 = demo ? ahora : mem[c.id];
    return t0 ? t0 + c.horas * 3600000 : 0;
  }

  /* 30-sep (Franco): a la hora de término la gift card SALE DEL CARRITO.
     Shopify ya no la acepta (el código vence a la misma hora), y además se
     quita del carrito de quien la tenía aplicada, dejando sus otros códigos. */
  var limpiando = false;
  function limpiarVencidas() {
    if (limpiando) return;
    var t = Date.now();
    var vencidos = CAMPANAS.filter(function (c) {
      return c.tipo === 'ventana' && t > Date.parse(c.hasta) && t - Date.parse(c.hasta) < 7 * 864e5;
    }).map(function (c) { return c.codigo.toUpperCase(); });
    if (!vencidos.length) return;
    limpiando = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codigos = (cart.discount_codes || []).map(function (d) { return (d.code || '').toUpperCase(); });
        var niveles = (cart.cart_level_discount_applications || []).map(function (d) { return (d.title || '').toUpperCase(); });
        var tiene = vencidos.some(function (v) { return codigos.indexOf(v) > -1 || niveles.indexOf(v) > -1; });
        if (!tiene) return;
        var quedan = (cart.discount_codes || []).map(function (d) { return d.code; })
          .filter(function (c) { return vencidos.indexOf((c || '').toUpperCase()) === -1; });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: quedan.join(',') })
        }).then(function () { if (typeof window.refreshCart === 'function') window.refreshCart(); });
      })
      .catch(function () {})
      .finally(function () { limpiando = false; });
  }
  limpiarVencidas();

  /* campaña en juego: la del demo, o la primera activa y vigente */
  var C = null, FIN = 0, demo = false;
  if (mDemo) {
    CAMPANAS.forEach(function (c) { if (!C && c.id === mDemo[1]) { C = c; demo = true; } });
  }
  if (!C) {
    CAMPANAS.forEach(function (c) {
      if (C || !c.activa) return;
      var f = fin(c, false);
      if (f > ahora) C = c;
    });
  }
  if (!C) return;
  FIN = fin(C, demo);
  if (FIN <= ahora) return;

  function reloj(ms) {
    ms = Math.max(0, ms); var s = Math.floor(ms / 1000);
    var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (x < 10 ? '0' : '') + x;
  }
  var CLP = function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); };

  /* ---------------- ESTILOS ---------------- */
  var css = '' +
  /* Tarjeta = la misma de /pages/hotlist-cyber (sección hotlist, .hl__gc), en px */
  '.ilev-hlc-w{position:relative;padding-top:12px}' +
  '.ilev-hlc-pill{position:absolute;z-index:3;top:0;right:10px;transform:rotate(5deg);font-size:10px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;white-space:nowrap;color:#4B384C;background:#B6DCE1;padding:3px 8px;border-radius:99px;box-shadow:0 3px 7px rgba(25,15,50,.3);line-height:1.2}' +
  '.ilev-hlc{position:relative;overflow:hidden;border-radius:12px;padding:15px 14px 13px;display:flex;flex-direction:column;align-items:flex-start;gap:9px;text-align:left;color:#fff;font-size:11.5px;line-height:1.15;' +
    'background:radial-gradient(60% 70% at 85% 12%,rgba(255,255,255,.22),rgba(255,255,255,0) 70%),linear-gradient(135deg,#4B384C 0%,#5E4462 45%,#85648B 100%);' +
    'box-shadow:0 4px 11px rgba(25,15,50,.38),inset 0 0 0 1px rgba(255,255,255,.12);transition:filter .4s}' +
  '.ilev-hlc::before{content:"";position:absolute;top:-20%;bottom:-20%;left:0;width:38%;pointer-events:none;background:linear-gradient(100deg,rgba(255,255,255,0) 0%,rgba(255,255,255,.26) 50%,rgba(255,255,255,0) 100%);transform:translate3d(-120%,0,0) skewX(-12deg);animation:ilevHlcBrillo 3.2s ease-in-out 1s infinite}' +
  '@keyframes ilevHlcBrillo{0%{transform:translate3d(-120%,0,0) skewX(-12deg)}60%,100%{transform:translate3d(320%,0,0) skewX(-12deg)}}' +
  '.ilev-hlc__marca{font-size:10px;font-weight:800;letter-spacing:.16em;text-transform:uppercase;white-space:nowrap}' +
  '.ilev-hlc__monto{display:flex;align-items:center;gap:7px;font-size:34px;font-weight:800;letter-spacing:-.02em;line-height:1;white-space:nowrap}' +
  '.ilev-hlc__chip{flex:0 0 auto;width:24px;height:19px;border-radius:4px;background:linear-gradient(135deg,#F1DDA0 0%,#D4B46A 55%,#E9D08D 100%);box-shadow:inset 0 0 0 1px rgba(120,90,30,.25)}' +
  '.ilev-hlc__cond{font-size:12px;line-height:1.25}' +
  '.ilev-hlc__cond b,.ilev-hlc__val b{color:#B6DCE1;font-weight:800;white-space:nowrap}' +
  '.ilev-hlc__val{display:flex;align-items:center;gap:5px;background:rgba(25,15,40,.32);border-radius:6px;padding:5px 7px;font-size:10.5px;font-weight:600;line-height:1.25}' +
  '.ilev-hlc__val svg{flex:0 0 auto;width:11px;height:11px}' +
  '.ilev-hlc__val b{font-variant-numeric:tabular-nums}' +
  '.ilev-hlc__ok{position:absolute;right:12px;top:13px;background:#B6DCE1;color:#4B384C;border-radius:99px;padding:4px 10px;font-size:11px;font-weight:800;white-space:nowrap}' +
  '#ilev-gc{margin:4px 0 12px;font-family:inherit}' +
  '#ilev-gc .gc__txt{margin-top:9px;font-size:12.5px;line-height:1.35;color:#4B384C}' +
  '#ilev-gc .gc__txt strong{color:#4B384C;font-weight:800}' +
  '#ilev-gc .gc__bar{height:6px;border-radius:6px;background:#EDE6EE;margin-top:7px;overflow:hidden}' +
  '#ilev-gc .gc__fill{height:100%;border-radius:6px;background:#85648B;transition:width .6s ease}' +
  '#ilev-gc .gc__btn{margin-top:9px;width:100%;border:0;border-radius:10px;padding:11px 12px;font-weight:800!important;font-size:13.5px;text-transform:none!important;letter-spacing:0!important;background:#B6DCE1;color:#4B384C;cursor:pointer}' +
  '#ilev-gc .gc__btn[disabled]{opacity:.6;cursor:wait}' +
  '#ilev-gc.is-lock .ilev-hlc{filter:saturate(.55)}' +
  '#ilev-gc.is-pop .ilev-hlc-w{animation:ilevGcPop .55s cubic-bezier(.2,1.4,.4,1)}' +
  '@keyframes ilevGcPop{0%{transform:scale(.94)}100%{transform:scale(1)}}' +
  '#AjaxCartSubtotal .cart__discounts strong.ilev-gc-linea{color:#4B384C!important}' +
  '@media (prefers-reduced-motion:reduce){.ilev-hlc::before,#ilev-gc.is-pop .ilev-hlc-w{animation:none}}';
  var st = document.createElement('style');
  st.id = 'ilev-gc-css';
  st.textContent = css;
  document.head.appendChild(st);

  /* 30-sep: POP-UP al pasar el mínimo, con la visual del hero CYBER del home */
  var cssPop = '' +
  '#ilev-gcp{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(25,31,43,.55);opacity:0;visibility:hidden;transition:opacity .35s ease,visibility 0s linear .35s;font-family:Archivo,inherit,sans-serif}' +
  '#ilev-gcp.is-open{opacity:1;visibility:visible;transition:opacity .35s ease}' +
  '#ilev-gcp .p{position:relative;isolation:isolate;overflow:hidden;width:100%;max-width:400px;border-radius:24px;background:#B7DDE2;color:#191F2B;padding:26px 22px 20px;text-align:center;box-shadow:0 30px 70px rgba(20,10,60,.35);transform:translateY(18px) scale(.96);transition:transform .5s cubic-bezier(.2,1.2,.4,1)}' +
  '#ilev-gcp.is-open .p{transform:none}' +
  '#ilev-gcp .muro{position:absolute;inset:-10%;z-index:-1;pointer-events:none;background:repeating-linear-gradient(0deg,rgba(255,255,255,.16) 0 1px,transparent 1px 44px),repeating-linear-gradient(90deg,rgba(255,255,255,.16) 0 1px,transparent 1px 44px);animation:ilevGcpMuro 26s ease-in-out infinite alternate}' +
  '#ilev-gcp .luz{position:absolute;inset:0;z-index:-1;pointer-events:none;background:repeating-linear-gradient(118deg,rgba(255,255,255,.12) 0 50px,transparent 50px 120px);-webkit-mask-image:linear-gradient(90deg,#000,transparent 60%);mask-image:linear-gradient(90deg,#000,transparent 60%)}' +
  '#ilev-gcp .fx{position:absolute;inset:0;z-index:-1;pointer-events:none;opacity:.7;background:radial-gradient(55% 70% at 8% 0%,rgba(255,255,255,.42),rgba(255,255,255,0) 72%),radial-gradient(42% 60% at 80% 60%,rgba(255,255,255,.34),rgba(255,255,255,0) 70%)}' +
  '#ilev-gcp .fl{position:absolute;z-index:-1;border-radius:50%;pointer-events:none;background:radial-gradient(circle at 35% 40%,rgba(255,214,64,.95) 0 18%,rgba(255,200,40,0) 46%),radial-gradient(circle at 66% 58%,rgba(255,196,36,.85) 0 14%,rgba(255,196,36,0) 40%),radial-gradient(circle,rgba(255,210,60,.35) 0 30%,rgba(255,210,60,0) 70%);animation:ilevGcpDrift 14s ease-in-out infinite alternate}' +
  '#ilev-gcp .k{position:absolute;z-index:0;animation:ilevGcpDrift 11s ease-in-out infinite alternate}' +
  '#ilev-gcp .k i{--kc:#7a2be0;display:grid;place-items:center;width:38px;aspect-ratio:1/.92;border-radius:18%;font-style:normal;font-size:16px;font-weight:600;line-height:1;color:rgba(255,255,255,.92);background:linear-gradient(160deg,color-mix(in srgb,var(--kc) 78%,#fff) 0%,var(--kc) 55%,color-mix(in srgb,var(--kc) 80%,#000) 100%);box-shadow:inset 0 -.14em 0 color-mix(in srgb,var(--kc) 70%,#000),0 .6em 1em rgba(20,10,60,.25)}' +
  '@keyframes ilevGcpDrift{from{transform:translate3d(0,0,0) rotate(-8deg)}to{transform:translate3d(8px,-12px,0) rotate(8deg)}}' +
  '@keyframes ilevGcpMuro{from{transform:translate3d(-3%,-2%,0)}to{transform:translate3d(3%,2%,0)}}' +
  '#ilev-gcp .x{position:absolute;top:10px;right:12px;z-index:2;width:32px;height:32px;border:0;border-radius:50%;background:rgba(255,255,255,.55);color:#191F2B;font-size:18px;line-height:1;cursor:pointer}' +
  '#ilev-gcp .logo{display:block;width:52%;max-width:200px;height:auto;margin:6px auto 4px;position:relative;z-index:1}' +
  '#ilev-gcp .eyb{position:relative;z-index:1;margin:0;font-size:11px;font-weight:700;letter-spacing:.18em;text-transform:uppercase;opacity:.72}' +
  '#ilev-gcp h3{position:relative;z-index:1;margin:6px 0 0;font-size:27px;font-weight:800;letter-spacing:-.035em;line-height:1.04;color:#191F2B;text-wrap:balance}' +
  '#ilev-gcp .sub{position:relative;z-index:1;margin:8px auto 0;max-width:30ch;font-size:14px;line-height:1.45;opacity:.86}' +
  '#ilev-gcp .card{position:relative;z-index:1;margin:16px auto 0;max-width:290px}' +
  '#ilev-gcp .cta{position:relative;z-index:1;display:flex;align-items:center;justify-content:center;width:100%;min-height:54px;margin-top:16px;border:0;border-radius:999px;background:#191F2B;color:#fff;font:800 15.5px/1 Archivo,inherit,sans-serif!important;font-weight:800!important;letter-spacing:-.01em;text-transform:none!important;cursor:pointer;transition:transform .22s,opacity .22s}' +
  '#ilev-gcp .cta:hover{transform:translateY(-1px);opacity:.93}' +
  '#ilev-gcp .cta[disabled]{opacity:.7;cursor:wait}' +
  '#ilev-gcp .cta.ok{background:#1F6B64}' +
  '#ilev-gcp .no{position:relative;z-index:1;margin-top:10px;border:0;background:none;color:#191F2B;font-size:12.5px;font-weight:600!important;text-transform:none!important;letter-spacing:0!important;text-decoration:underline;opacity:.7;cursor:pointer}' +
  '#ilev-gcp .err{position:relative;z-index:1;margin:8px 0 0;font-size:12px;font-weight:700;color:#8a1c2b}' +
  '@media (max-height:680px){#ilev-gcp .p{padding:16px 18px 12px}#ilev-gcp .logo{width:34%;margin:0 auto 2px}#ilev-gcp h3{font-size:22px}#ilev-gcp .sub{margin-top:4px;font-size:13px}#ilev-gcp .card{margin-top:8px}#ilev-gcp .cta{min-height:44px;margin-top:10px}#ilev-gcp .no{margin-top:6px}}' +
  '@media (prefers-reduced-motion:reduce){#ilev-gcp .muro,#ilev-gcp .fl,#ilev-gcp .k{animation:none}#ilev-gcp .p{transition:none}}';
  var st2 = document.createElement('style');
  st2.id = 'ilev-gcp-css';
  st2.textContent = cssPop;
  document.head.appendChild(st2);


  /* La misma tarjeta de /pages/hotlist-cyber: marca, monto con chip, condición y reloj */
  function tarjetaHL(aplicada, attrT) {
    return '<div class="ilev-hlc-w"><span class="ilev-hlc-pill">' + C.etiqueta + '</span>' +
      '<div class="ilev-hlc" role="img" aria-label="ILEV · Gift card ' + CLP(C.monto) + '">' +
        '<span class="ilev-hlc__marca">ILEV · Gift card</span>' +
        '<div class="ilev-hlc__monto"><span class="ilev-hlc__chip"></span>' + CLP(C.monto) + '</div>' +
        '<div class="ilev-hlc__cond">Válida en pedidos desde <b>' + CLP(C.minimo) + '</b></div>' +
        '<div class="ilev-hlc__val"><svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" stroke-width="1.5"></circle><path d="M8 4.5V8l2.3 1.6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg><span>' + (aplicada ? C.txtPaga : C.txtVence) + ' · <b ' + attrT + '>' + reloj(FIN - Date.now()) + '</b></span></div>' +
        (aplicada ? '<span class="ilev-hlc__ok">✓ Activada · −' + CLP(C.monto) + '</span>' : '') +
      '</div></div>';
  }

  /* ---------------- LÓGICA ---------------- */
  var estadoPrevio = null, aplicando = false;

  function tieneCodigo(cart) {
    var K = C.codigo.toUpperCase();
    var c = (cart.discount_codes || []).some(function (d) { return (d.code || '').toUpperCase() === K; });
    var a = (cart.cart_level_discount_applications || []).some(function (d) { return (d.title || '').toUpperCase() === K; });
    return { puesto: c || a, aplicado: a };
  }

  function montaje() {
    var sub = document.getElementById('AjaxCartSubtotal');
    if (!sub) return null;
    var el = document.getElementById('ilev-gc');
    if (!el) { el = document.createElement('div'); el.id = 'ilev-gc'; sub.parentNode.insertBefore(el, sub); }
    return el;
  }

  var demoOn = false;
  function pintar(cart) {
    var el = montaje();
    if (!el) return;
    if (demoOn) return;
    var cod = tieneCodigo(cart);
    if (cod.puesto && !mem[C.id]) { mem[C.id] = ahora; guardar(mem); }
    var visible = demo || C.todos || cod.puesto || !!mem[C.id];
    if (!cart.item_count) rearmarPop();
    if (!visible || !cart.item_count || FIN <= Date.now()) { el.innerHTML = ''; el.className = ''; return; }

    var total = cart.total_price / 100;
    var sub = cod.aplicado ? total + C.monto : total;
    var falta = Math.max(0, C.minimo - sub);
    var estado = cod.aplicado ? 'on' : (falta > 0 ? 'lock' : 'lista');

    var body;
    if (estado === 'lock') {
      var pct = Math.min(100, Math.round(sub / C.minimo * 100));
      body = tarjetaHL(false, 'data-ilev-gc-t') +
             '<div class="gc__txt">🔒 Te faltan <strong>' + CLP(falta) + '</strong> para usar tu gift card.</div>' +
             '<div class="gc__bar"><div class="gc__fill" style="width:' + pct + '%"></div></div>';
    } else if (estado === 'lista') {
      body = tarjetaHL(false, 'data-ilev-gc-t') +
             '<button type="button" class="gc__btn" data-ilev-gc-usar>Usar mi gift card</button>';
    } else {
      body = tarjetaHL(true, 'data-ilev-gc-t');
    }
    el.className = 'is-' + estado + (estadoPrevio && estadoPrevio !== 'on' && estado === 'on' ? ' is-pop' : '');
    el.innerHTML = body;
    estadoPrevio = estado;
    var btn = el.querySelector('[data-ilev-gc-usar]');
    if (btn) btn.addEventListener('click', function (e) { if (demo) { abrirCarrito(); return; } usar(e); });
    renombrarLinea();
    /* 30-sep (Franco): al pasar el mínimo aparece un POP-UP para activarla
       (reemplaza al auto-aplicado). Una vez por visita; si lo cierra, la
       tarjeta del carrito sigue con su botón. */
    /* 30-sep: si el carrito baja del mínimo, el pop-up se rearma: vuelve a salir al pasar otra vez los $50.000 */
    if (estado === 'lock') rearmarPop();
    if (estado === 'lista' && !popVisto()) abrirPop();
    if (estado === 'on' && popAbierto()) popOk();
  }

  /* ---------------- POP-UP ---------------- */
  var CLAVE_POP = 'ilev_gc_pop_' + C.id;
  function rearmarPop() { window.__ilevGcPop = false; try { sessionStorage.removeItem(CLAVE_POP); } catch (e) {} }
  function popVisto() { try { return sessionStorage.getItem(CLAVE_POP) === '1'; } catch (e) { return !!window.__ilevGcPop; } }
  function marcarPop() { window.__ilevGcPop = true; try { sessionStorage.setItem(CLAVE_POP, '1'); } catch (e) {} }
  function popAbierto() { var p = document.getElementById('ilev-gcp'); return !!(p && p.classList.contains('is-open')); }
  function cerrarPop() {
    var p = document.getElementById('ilev-gcp'); if (!p) return;
    p.classList.remove('is-open');
    document.removeEventListener('keydown', escPop);
  }
  function escPop(e) { if (e.key === 'Escape') cerrarPop(); }
  function abrirPop() {
    marcarPop();
    var p = document.getElementById('ilev-gcp');
    if (!p) {
      p = document.createElement('div');
      p.id = 'ilev-gcp';
      p.setAttribute('role', 'dialog');
      p.setAttribute('aria-modal', 'true');
      p.setAttribute('aria-labelledby', 'ilev-gcp-t');
      var teclas = [['C', 6, 10], ['Y', 13, 23], ['B', 72, 7], ['E', 79, 18], ['R', 83, 30]].map(function (k, i) {
        return '<span class="k" style="left:' + k[1] + '%;top:' + k[2] + '%;animation-delay:-' + (i * 2.1) + 's" aria-hidden="true"><i>' + k[0] + '</i></span>';
      }).join('');
      var flores = [[-6, 58, 110], [82, 70, 130], [30, 92, 90]].map(function (f, i) {
        return '<span class="fl" style="left:' + f[0] + '%;top:' + f[1] + '%;width:' + f[2] + 'px;height:' + f[2] + 'px;animation-delay:-' + (i * 3) + 's" aria-hidden="true"></span>';
      }).join('');
      p.innerHTML = '<div class="p">' +
        '<span class="muro" aria-hidden="true"></span><span class="luz" aria-hidden="true"></span><span class="fx" aria-hidden="true"></span>' + flores + teclas +
        '<button type="button" class="x" aria-label="Cerrar" data-gcp-x>×</button>' +
        '<img class="logo" src="/cdn/shop/files/ilev-hero-cyber-logotema.webp?v=1790630056&width=600" alt="Cyber Hair ILEV" width="600" height="220">' +
        '<p class="eyb">' + C.etiqueta + '</p>' +
        '<h3 id="ilev-gcp-t">¡Desbloqueaste tu gift card!</h3>' +
        '<p class="sub">Tu pedido pasó los ' + CLP(C.minimo) + '. Actívala y se descuenta al tiro.</p>' +
        '<div class="card">' + tarjetaHL(false, 'data-gcp-t') + '</div>' +
        '<button type="button" class="cta" data-gcp-usar>Activar mi gift card</button>' +
        '<div class="err" data-gcp-err hidden></div>' +
        '<button type="button" class="no" data-gcp-x>Ahora no</button>' +
      '</div>';
      document.body.appendChild(p);
      p.addEventListener('click', function (e) { if (e.target === p || e.target.hasAttribute('data-gcp-x')) cerrarPop(); });
      p.querySelector('[data-gcp-usar]').addEventListener('click', function (e) {
        var b = e.currentTarget; b.disabled = true; b.textContent = 'Activando…';
        if (demo) { setTimeout(popOk, 700); return; }   /* vista de prueba: no toca el carrito */
        usar(null, function (ok) { if (!ok) popError(); });
      });
    }
    var bu = p.querySelector('[data-gcp-usar]'), er0 = p.querySelector('[data-gcp-err]');
    if (bu) { bu.disabled = false; bu.classList.remove('ok'); bu.textContent = 'Activar mi gift card'; }
    if (er0) er0.hidden = true;
    requestAnimationFrame(function () { p.classList.add('is-open'); var b = p.querySelector('[data-gcp-usar]'); if (b) b.focus(); });
    document.addEventListener('keydown', escPop);
  }
  function popOk() {
    var b = document.querySelector('#ilev-gcp [data-gcp-usar]'); if (!b) return;
    if (b.classList.contains('ok')) return;
    b.disabled = true; b.classList.add('ok'); b.textContent = '✓ Activada · −' + CLP(C.monto);
    setTimeout(function () { cerrarPop(); abrirCarrito(); }, 1200);
  }
  /* 30-sep (Franco): después de activarla, el carrito lateral queda abierto
     y muestra la gift card activada. */
  function abrirCarrito() {
    try {
      if (window.ILEV_CARRITO && typeof window.ILEV_CARRITO.abrir === 'function') { window.ILEV_CARRITO.abrir(); }
      else { var sd = document.getElementById('site-cart-sidebar'); if (sd && typeof sd.show === 'function' && !sd.opened) sd.show(); }
    } catch (e) {}
    if (demo) { var el = document.getElementById('ilev-gc'); if (el) { el.className = 'is-on is-pop'; el.innerHTML = tarjetaHL(true, 'data-ilev-gc-t'); demoOn = true; } }
    else { setTimeout(leerCarrito, 250); }
  }
  function popError() {
    var b = document.querySelector('#ilev-gcp [data-gcp-usar]'), er = document.querySelector('#ilev-gcp [data-gcp-err]');
    if (b) { b.disabled = false; b.textContent = 'Activar mi gift card'; }
    if (er) { er.hidden = false; er.textContent = 'No se pudo activar. Prueba con el botón del carrito.'; }
  }

  /* En el pie del carrito, el código pasa a leerse como gift card */
  function renombrarLinea() {
    document.querySelectorAll('#AjaxCartSubtotal .cart__discounts strong').forEach(function (s) {
      if (s.textContent.toUpperCase().indexOf(C.codigo.toUpperCase()) > -1) {
        s.textContent = '🎁 Gift Card ' + C.etiqueta + ' (−' + CLP(C.monto) + ')';
        s.classList.add('ilev-gc-linea');
      }
    });
  }

  function usar(e, cb) {
    if (aplicando) return;
    aplicando = true;
    if (e && e.currentTarget) { e.currentTarget.disabled = true; e.currentTarget.textContent = 'Aplicando…'; }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: C.codigo })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (typeof window.refreshCart === 'function') window.refreshCart();
        if (cb) cb(tieneCodigo(cart).aplicado);
      })
      .catch(function () { if (cb) cb(false); })
      .finally(function () { aplicando = false; setTimeout(abrirCarrito, 350); });
  }

  var tm = null;
  function leerCarrito() {
    clearTimeout(tm);
    tm = setTimeout(function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(pintar)
        .catch(function () {});
    }, 120);
  }

  function vigilar() {
    var sub = document.getElementById('AjaxCartSubtotal');
    if (!sub) return false;
    new MutationObserver(leerCarrito).observe(sub, { childList: true });
    leerCarrito();
    return true;
  }
  var n = 0;
  (function esperar() { if (vigilar()) return; if (++n > 80) return; setTimeout(esperar, 150); })();
  document.addEventListener('cart-updated', leerCarrito, true);

  /* cuenta regresiva: cada segundo; al vencer, la tarjeta se va */
  setInterval(function () {
    var r = FIN - Date.now();
    var t = document.querySelector('[data-ilev-gc-t]');
    if (t) t.textContent = reloj(r);
    var tp = document.querySelector('[data-gcp-t]');
    if (tp) tp.textContent = reloj(r);
    if (r <= 0) { cerrarPop(); if (!demo && !window.__ilevGcVencio) { window.__ilevGcVencio = true; setTimeout(limpiarVencidas, 1500); } }
    if (r <= 0) { var el = document.getElementById('ilev-gc'); if (el) { el.innerHTML = ''; el.className = ''; } }
  }, 1000);
})();
